import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { getOutlineClasses, getStateClasses } from '../../utils/taillwind.js';

const Badge = /*#__PURE__*/forwardRef(function Badge(props, ref) {
  const {
    children,
    compact = false,
    outline = false,
    state,
    ...otherProps
  } = props;
  const className = cn('rounded-full border font-bold text-xs uppercase overflow-hidden whitespace-nowrap inline-flex items-center justify-center', {
    [getOutlineClasses(state)]: outline,
    [`border-transparent ${getStateClasses(state)}`]: !outline,
    'h-2 w-2 min-w-0': compact,
    'h-5 py-0 px-1.5': !compact
  }, props.className);
  return createElement("span", Object.assign({}, otherProps, {
    "aria-atomic": "true",
    "aria-live": "polite",
    className: className,
    "data-taco": "badge",
    ref: ref,
    role: "status",
    title: props['aria-label']
  }), compact ? createElement(VisuallyHidden, null, children) : children);
});

export { Badge };
//# sourceMappingURL=Badge.js.map
